// extracted by mini-css-extract-plugin
export default {"root":"Logo_root__w23n4","logo":"Logo_logo__Tem6P","container":"Logo_container__ymKJz","avatar":"Logo_avatar__+oiJC","delete":"Logo_delete__zJo7j"};